/* Footer Noclout (sections/nc-footer.liquid), 3 novembre 2026.
   1. Le bouton flottant Joy « Le Club » se cache quand le footer est à l'écran (classe ncf-on sur <html>) :
      le Club est dans la ligne du bas du footer.
   2. Le solde de points du client, lu sur le bouton Joy, s'affiche à côté de « Le Club ».
   3. « Le Club » ouvre le widget Joy, comme le bouton flottant (repli : la page Club).
   4. Un seul menu déroulant ouvert à la fois, fermé au clic ailleurs.
   6. La pastille Judge.me ouvre l'aperçu des avis de la boutique, en passant le clic au vrai badge (caché).
   7. « Cookies » (menu des mentions légales) ouvre les préférences du bandeau de consentement Shopify
      (window.privacyBanner, aucune app tierce). Repli : la page des mentions légales.
   5. Follow on Shop : une fois suivi, Shopify réduit le fond violet à un rond et passe le texte en noir,
      illisible sur le fond noir. On injecte un style dans son shadow DOM : fond violet plein, texte blanc. */
(function () {
  var f = document.querySelector('[data-ncf]');
  if (!f) return;

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      document.documentElement.classList.toggle('ncf-on', e[0].isIntersecting);
      if (!e[0].isIntersecting) document.documentElement.classList.remove('ncf-joy');
    }, { rootMargin: '0px 0px -40px 0px' }).observe(f);
  }

  var pts = f.querySelector('[data-ncf-points]');
  var tries = 0;
  var read = function () {
    var b = document.querySelector('#Avada-Joy_FloatingButton button, .joy-fab-pb');
    var m = b && (b.textContent || '').match(/(\d[\d\s.,]*)\s*$/);
    if (m && pts) {
      var n = m[1].trim();
      pts.textContent = n;
      // Sur téléphone, le solde s'écrit en entier (« 0 point », « 120 points ») : voir nc-footer.css
      var v = parseInt(n.replace(/\D/g, ''), 10) || 0;
      pts.setAttribute('data-unit', pts.getAttribute('data-fr') ? (v > 1 ? 'points' : 'point') : (v === 1 ? 'point' : 'points'));
      pts.hidden = false;
      return;
    }
    if (++tries < 20) setTimeout(read, 500);
  };
  read();

  var club = f.querySelector('[data-ncf-club]');
  if (club) club.addEventListener('click', function (e) {
    var j = window.joyInstance;
    var open = j && typeof j.openWidget === 'function' ? function () { j.openWidget(); } : (typeof window.avadaJoyTrigger === 'function' ? window.avadaJoyTrigger : null);
    if (!open) return;
    e.preventDefault();
    // Le widget vit dans le conteneur du bouton flottant : on le laisse visible le temps de l'ouverture
    document.documentElement.classList.add('ncf-joy');
    try { open(); } catch (err) { window.location.href = club.href; }
    // Quand le widget se referme, le bouton flottant redevient caché sur le footer
    var seen = false, n = 0;
    var t = setInterval(function () {
      var w = document.querySelector('#Avada-Joy_FloatingButton joy-loyalty-widget');
      var isOpen = !!(w && (w._isOpen || w.hasAttribute('open')));
      if (isOpen) seen = true;
      if ((seen && !isOpen) || ++n > 1200) {
        document.documentElement.classList.remove('ncf-joy');
        clearInterval(t);
      }
    }, 250);
  });

  var shopCss = 'button > div:first-child { width: 100% !important; background-color: #5a31f4 !important; } button span, button > div { color: #fff !important; }';
  var fixShop = function () {
    f.querySelectorAll('shop-follow-button').forEach(function (b) {
      var r = b.shadowRoot;
      if (!r) return;
      if (!r.querySelector('style[data-ncf]')) {
        var st = document.createElement('style');
        st.setAttribute('data-ncf', '');
        st.textContent = shopCss;
        r.appendChild(st);
      }
      if (!b.__ncf) {
        b.__ncf = true;
        new MutationObserver(fixShop).observe(r, { childList: true });
      }
    });
  };
  var shopTries = 0;
  (function wait() { fixShop(); if (++shopTries < 20) setTimeout(wait, 500); })();

  var jm = f.querySelector('[data-ncf-jm]');
  if (jm) {
    var openJm = function () {
      var b = f.querySelector('.ncf__jm-src .jdgm-trust-badge--clickable');
      if (b) b.click();
    };
    jm.addEventListener('click', openJm);
    jm.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openJm(); } });
  }

  var ck = f.querySelector('[data-ncf-cookies]');
  if (ck) ck.addEventListener('click', function (e) {
    var pb = window.privacyBanner;
    if (!pb || typeof pb.showPreferences !== 'function') return;
    e.preventDefault();
    var d = ck.closest('details');
    if (d) d.open = false;
    pb.showPreferences();
  });

  var menus = f.querySelectorAll('details.ncf__menu');
  menus.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      menus.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
  document.addEventListener('click', function (e) {
    menus.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
  });
})();
